import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import '../styles/Impressum.css';
import ScrollAnimation from '../components/ScrollAnimation';

const Impressum: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="impressum-page">
      <div className="impressum-container">
        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <h1 className="impressum-title">{t('impressumTitle')}</h1>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <h3>{t('impressumLegalInfo')}</h3>
            <div className="impressum-content">
              <p>{t('impressumResponsibleCompany')}</p>
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('impressumCompanyAddress')) }} />
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <h3>{t('impressumRegisterEntry')}</h3>
            <div className="impressum-content">
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('impressumRegisterInfo')) }} />
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <h3>{t('impressumVAT')}</h3>
            <div className="impressum-content">
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('impressumVATInfo')) }} />
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <h3>{t('impressumPostalAddress')}</h3>
            <div className="impressum-content">
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('impressumCompanyAddress')) }} />
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <h3>{t('impressumRepresentedBy')}</h3>
            <div className="impressum-content">
              <p>{t('impressumManagingDirector')}</p>
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <h3>{t('impressumContact')}</h3>
            <div className="impressum-content">
              <p>
                {t('impressumPhone')} &nbsp;&nbsp;+49 66 22 – 43 000 – 0<br />
                {t('impressumFax')} &nbsp;&nbsp;+49 66 22 –  43 000 – 11 88 <br />
                {t('impressumEmail')} &nbsp;&nbsp;&nbsp;<a href="mailto:info@votera.de">info@votera.de</a>
              </p>
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <h3>{t('impressumDisputeResolution')}</h3>
            <div className="impressum-content">
              <p>{t('impressumDisputeResolutionText')}</p>
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <div className="impressum-content">
              <h3>{t('impressumLiabilityContent')}</h3>
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('impressumLiabilityContentText')) }} />
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <div className="impressum-content">
              <h3>{t('impressumLiabilityLinks')}</h3>
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('impressumLiabilityLinksText')) }} />
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <div className="impressum-content">
              <h3>{t('impressumCopyright')}</h3>
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('impressumCopyrightText')) }} />
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="impressum-section">
            <div className="impressum-content">
              <h3>{t('impressumImageRights')}</h3>
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('impressumImageRightsText')) }} />
            </div>
          </section>
        </ScrollAnimation>
      </div>
    </div>
  );
};

export default Impressum;
